import * as RxTabs from "@radix-ui/react-tabs";
import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import styles from "./index.module.scss";

import {
  formatInteger$Compact,
  formatInteger$Standard,
} from "@/modules/common-utils/format";

interface IClassName {
  className?: string;
  style?: React.CSSProperties;
}

interface IChildren {
  content?: React.ReactNode;
  children?: React.ReactNode;
}

type Option = {
  value: string;
  label: string;
  badge?: number;
  disabled?: boolean;
  hidden?: boolean;
};

function Root({
  value,
  onChange,
  content,
  children = content,
}: IChildren & {
  value: string;
  onChange?: (value: string) => void;
}) {
  return (
    <RxTabs.Root value={value} onValueChange={onChange}>
      {children}
    </RxTabs.Root>
  );
}

function List({
  className,
  style,
  options,
}: IClassName & { options: Option[] }) {
  return (
    <RxTabs.List className={cx(className, styles.list)} style={style}>
      {options.map((item, index) =>
        item.hidden ? null : (
          <RxTabs.Trigger
            className={styles.trigger}
            value={item.value}
            key={index}
            disabled={item.disabled}
          >
            <Flex.Row alignItems="center" gap="4px">
              <span>{item.label}</span>
              {item.badge != null ? (
                <Flex.Row
                  alignItems="center"
                  justifyContent="center"
                  className={styles.badge}
                  title={formatInteger$Standard(item.badge)}
                >
                  {formatInteger$Compact(item.badge)}
                </Flex.Row>
              ) : undefined}
            </Flex.Row>
          </RxTabs.Trigger>
        )
      )}
    </RxTabs.List>
  );
}

function Page({
  className,
  style,
  value,
  content,
  children = content,
}: IClassName & IChildren & { value: string }) {
  return (
    <RxTabs.Content
      className={cx(styles.content, className)}
      style={style}
      value={value}
      forceMount
    >
      {children}
    </RxTabs.Content>
  );
}

const Tabs = { Root, List, Page };

export default Tabs;
